var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: none;\n  border: 0;\n  color: #888;\n\n  &:hover {\n    > span {\n      text-decoration: underline;\n    }\n  }\n'], ['\n  background: none;\n  border: 0;\n  color: #888;\n\n  &:hover {\n    > span {\n      text-decoration: underline;\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import InputWrapper from '../wrappers/InputWrapper';
import withFormValidations from 'react-validator';
import styled from 'styled-components';
import Button from '../Button';
import { Form, Group } from '../forms/StyledComponents';
import { AlternateCTA } from './StyledComponents';

var SendButton = Button.extend(_templateObject);

var BackButton = styled.button(_templateObject2);

var Forgot = function (_React$Component) {
  _inherits(Forgot, _React$Component);

  function Forgot() {
    var _temp, _this, _ret;

    _classCallCheck(this, Forgot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      confirm: false,
      errors: null
    }, _this.cancel = function (e) {
      e.preventDefault();

      _this.props.goBack();
    }, _this.send = function (e) {
      e.preventDefault();

      if (_this.props.valid()) {
        _this.props.forgotCallback(_this.props.inputs).then(function (res) {
          return _this.setState({ confirm: true });
        }).catch(function (err) {
          return _this.setState({ errors: err[0] });
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Forgot.prototype.render = function render() {
    var _props = this.props,
        field = _props.field,
        onChange = _props.onChange,
        valid = _props.valid;


    return React.createElement(
      Form,
      { name: 'forgot' },
      this.state.errors && React.createElement(
        'div',
        null,
        this.state.errors.title,
        ' ',
        this.state.errors.detail
      ),
      !this.state.confirm && React.createElement(
        'div',
        null,
        React.createElement(
          Group,
          null,
          React.createElement(
            'label',
            { htmlFor: 'email' },
            'Email'
          ),
          React.createElement(InputWrapper, {
            id: 'email',
            input: field('email'),
            onChange: onChange,
            type: 'email',
            valid: valid
          })
        ),
        React.createElement(
          SendButton,
          { type: 'submit', onClick: this.send },
          'Send Link'
        ),
        React.createElement(
          AlternateCTA,
          null,
          React.createElement(
            BackButton,
            { text: true, onClick: this.cancel },
            React.createElement(
              'span',
              null,
              'Back to Log In'
            )
          )
        )
      ),
      this.state.confirm && React.createElement(
        'div',
        null,
        React.createElement(
          'h5',
          null,
          'Check your email!'
        ),
        React.createElement(
          'p',
          null,
          'An email has been sent to the address provided with a link that will automatically log you into your account.'
        ),
        React.createElement(
          'button',
          { type: 'button', onClick: this.cancel },
          'Close'
        )
      )
    );
  };

  return Forgot;
}(React.Component);

Forgot.propTypes = process.env.NODE_ENV !== "production" ? {
  goBack: PropTypes.func,
  forgotCallback: PropTypes.func.isRequired,
  actionCallback: PropTypes.func.isRequired
} : {};

export default withFormValidations(Forgot, [{
  label: 'email',
  rules: [{
    rule: 'email',
    message: 'Invalid email address'
  }, {
    rule: 'required',
    message: 'An email address is required'
  }]
}]);


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/auth/Forgot.js
// module id = 769
// module chunks = 4